import aliasMutations from "./mutations.js";
import aliasActions from "./actions.js";
import aliasGetters from "./getters.js";

export default {
    namespaced: true,
    state() {
        return {
        };
    },
    mutations: aliasMutations,
    actions: aliasActions,
    getters: aliasGetters,
};